import React from 'react';
import { accessibleTextColor } from '../utils/colorContrast';

const COLORS = [
  '#EE4040','#F0A30A','#7DBD43','#3BAED0',
  '#9B59B6','#E67E22','#27AE60','#E91E8C',
  '#2980B9','#D35400','#16A085','#8E44AD',
  '#C0392B','#F39C12','#1ABC9C','#2C3E50',
];

interface MiniWheelProps {
  names: string[];
  size?: number;
}

const MiniWheel: React.FC<MiniWheelProps> = ({ names, size = 80 }) => {
  const N = names.length;
  if (N === 0) return null;

  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 1;
  const sliceAngle = (2 * Math.PI) / N;

  const segments = names.map((_, i) => {
    const start = i * sliceAngle - Math.PI / 2;
    const end = start + sliceAngle;
    const x1 = cx + r * Math.cos(start);
    const y1 = cy + r * Math.sin(start);
    const x2 = cx + r * Math.cos(end);
    const y2 = cy + r * Math.sin(end);
    const largeArc = sliceAngle > Math.PI ? 1 : 0;
    const d = N === 1
      ? `M ${cx} ${cy} m -${r} 0 a ${r} ${r} 0 1 0 ${r * 2} 0 a ${r} ${r} 0 1 0 -${r * 2} 0`
      : `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} Z`;
    return { d, color: COLORS[i % COLORS.length] };
  });

  // The pointer sits at 3 o'clock, which is 90deg clockwise from where segment 0
  // starts (12 o'clock), so it rests on segment floor(N / 4). Same colour rule as
  // the slices above, so the pointer always matches what it points at.
  const pointerColor = COLORS[Math.floor(N / 4) % COLORS.length];
  const pointerStroke = accessibleTextColor(pointerColor) === '#ffffff' ? '#ffffff' : '#1a1a2e';

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {segments.map((seg, i) => (
        <path key={i} d={seg.d} fill={seg.color} stroke="white" strokeWidth="1.2" />
      ))}
      <circle cx={cx} cy={cy} r={size * 0.1} fill="white" />
      <circle cx={cx} cy={cy} r={size * 0.04} fill="#e2e8f0" />
      {/* pointer */}
      <polygon
        points={`${cx + r - 2},${cy} ${cx + r + 7},${cy - 4} ${cx + r + 7},${cy + 4}`}
        fill={pointerColor}
        stroke={pointerStroke}
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MiniWheel;
